// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__ODe9k","active":"PopoverSharedStyle_active__dlzp1","backdrop":"PopoverSharedStyle_backdrop__ViTza"};